'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _accounts = require('../../accounts');

var _accounts2 = _interopRequireDefault(_accounts);

var _paymentForm = require('../../payment-form');

var _paymentForm2 = _interopRequireDefault(_paymentForm);

var _locations = require('../../locations');

var _locations2 = _interopRequireDefault(_locations);

var _accounts3 = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.account', ['ui.router', 'ifeis.session', 'ngMaterial', 'ifeis.accounts', 'ifeis.schools', 'ifeis.payment-form', 'ifeis.locations']).config(function ($stateProvider) {
  $stateProvider.state('account', {
    abstract: true,
    url: '/account',
    template: require('./tpl.html'),
    controller: 'AccountController',
    resolve: {
      currentUser: function currentUser(fSession) {
        return fSession.user();
      },
      schools: function schools(fSchoolService) {
        return fSchoolService.all();
      }
    }
  }).state('account.profile', {
    url: '',
    template: require('./profile/profile.tpl.html'),
    ncyBreadcrumb: {
      label: 'Account'
    }
  }).state('account.competitors', {
    url: '/competitors/',
    template: require('./competitors/competitors.tpl.html'),
    ncyBreadcrumb: {
      label: 'Account'
    }
  }).state('account.billing', {
    url: '/billing/',
    template: require('./billing/billing.tpl.html'),
    ncyBreadcrumb: {
      label: 'Account'
    }
  });
}).run(function ($state, $rootScope) {
  $rootScope.$on('$stateChangeError', function (event, toState) {
    if (toState.name === 'account') {
      $state.go('check-auth', {}, { location: false });
    }
  });
}).controller('AccountController', function ($scope, $state, $q, $timeout, fPaymentFormDialog, fAccountService, msgService, currentUser, fSession, schools, $ngRedux, fLocationService) {
  $scope.user = currentUser;
  $scope.schools = schools;
  $scope.$state = $state;
  $scope.countries = fLocationService.countries;

  if ($scope.user.country) {
    $scope.provinces = fLocationService.provinces[$scope.user.country];
  } else {
    $scope.provinces = [];
  }

  $scope.$watch('profile.provinceName', function (newProvince, oldProvince) {
    if (newProvince !== oldProvince) {
      $scope.profile.province = fLocationService.getProvinceCode(newProvince, $scope.profile.country);
    }
  });

  $scope.$watch('profile.country', function (newCountry, oldCountry) {
    if (newCountry !== oldCountry) {
      $scope.provinces = fLocationService.provinces[$scope.profile.country];
    }
  });

  var profileInit = void 0;
  _refreshModel(currentUser);

  if (!$scope.profile.fname || !$scope.profile.lname) {
    $scope.forceStay = true;
    $timeout(function () {
      msgService.displayWarningMsg("You must enter a first and last name to proceed.");
    }, 500);
  }

  $scope.saveProfile = function (profile) {
    var acc = _prepareAccountDto(profile);
    if (!$scope.provinces.length) acc.province = null;

    fAccountService.me().then(function (acct) {
      return acct.update(acc).then(function (res) {
        $scope.forceStay = false;
        _refreshModel(res.get());
        $ngRedux.dispatch((0, _accounts3.getAccountForPerson)(res.get().id));
        $ngRedux.dispatch((0, _events.deleteEligibleEventsForPerson)(acc.id));
        msgService.displaySuccessMsg("Profile saved successfully");
      }, function (err) {
        return msgService.displayErrorMsg("Could not save your profile: " + err);
      });
    });
  };

  $scope.saveAccountCompetitor = function (accCompetitor) {
    var acc = _prepareAccountDto(accCompetitor);
    acc.province = profileInit.province;

    fAccountService.me().then(function (acct) {
      var promises = {
        update: acct.update(acc)
      };

      if (profileInit.school !== acc.school) {
        if (!acc.school && profileInit.school) {
          promises.school = acct.rmSchool();
        } else {
          promises.school = acct.setSchool(acc.school.id);
        }
      }

      return $q.all(promises);
    }).then(function (res) {
      var person = res.school || res.update;
      $ngRedux.dispatch((0, _accounts3.getAccountForPerson)(acc.id));
      $ngRedux.dispatch((0, _events.deleteEligibleEventsForPerson)(acc.id));
      $scope.forceStay = false;
      _refreshModel(person.get());
      msgService.displaySuccessMsg("Profile saved successfully");
    }, function (err) {
      return msgService.displayErrorMsg("Could not save your profile: " + err);
    });
  };

  // Update the editing status
  // that toggles Save btn disabled state

  $scope.updateEditing = function () {
    return $scope.editingProfile = !angular.equals($scope.profile, profileInit);
  };
  $scope.updateEditingComp = function () {
    return $scope.editingProfileComp = !angular.equals($scope.profileComp, profileInit);
  };

  // Open credit card payment form
  // to make a due payment right away

  $scope.openPaymentForm = function (event, due) {
    fPaymentFormDialog(event, due.balance && due.balance.balance || due.balance, profileInit, due.feis).then(function () {
      return _getPayments(profileInit);
    });
  };

  $scope.getAbbSchoolName = function (school) {
    var abbreviation = '';
    if (school.city) {
      abbreviation = ', ' + school.city;
    }
    if (school.state && school.country) {
      var countryCode = fLocationService.getCountryCode(school.country);
      var provinceCode = fLocationService.getProvinceCode(school.state, countryCode);
      abbreviation += ', ' + provinceCode + ', ' + countryCode;
    }
    return abbreviation;
  };

  // Refresh controller model

  function _refreshModel(user) {
    if (!user.payments || !user.paymentsDue) _getPayments(user);

    profileInit = angular.copy(user);

    $scope.editingProfile = false;
    $scope.editingProfileComp = false;

    $scope.profile = angular.copy(user);
    $scope.profileComp = angular.copy(user);
    $scope.profile.provinceName = fLocationService.getProvinceName($scope.profile.province, $scope.profile.country);
  }

  function _getPayments(user) {
    fAccountService.me().then(function (acct) {
      var promises = {
        payments: acct.payments(),
        paymentsDue: acct.paymentsDue()
      };

      return $q.all(promises).then(function (res) {
        var profile = angular.copy(profileInit);

        // Payments
        profile.payments = res.payments;
        profile.totalPayments = res.payments.map(function (d) {
          return d.amt;
        }).reduce(function (prev, curr) {
          return prev + curr;
        }, 0);

        // Payments Due
        profile.paymentsDue = res.paymentsDue;
        profile.totalPaymentsDue = res.paymentsDue.map(function (d) {
          return d.balance;
        }).reduce(function (prev, curr) {
          return prev + curr;
        }, 0);

        // Update profile model
        _refreshModel(profile);
      });
    });
  }

  // Create Account dto before saving
  // to avoid sending temp parameters attached to model

  function _prepareAccountDto(model) {

    return {
      // permanent props
      id: model.id,
      email: model.email,

      // profile props
      fname: model.fname,
      lname: model.lname,

      // address props
      address: model.address,
      address2: model.address2,
      city: model.city,
      country: model.country,
      province: model.province,
      zip: model.zip,

      // become a competitor props
      school: model.school,
      dob: model.dob,
      champion: model.champion,
      gender: model.gender,

      // dependents props
      public_reg: model.public_reg
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./routes/account/index.js
// module id = 510
// module chunks = 0